import React, { useEffect, useRef } from 'react';
import AbcNotation from './AbcNotation';
import { cleanAndFillAbc } from '../utils/cleanAndFillAbc';
import { normalizeType, normalizeKey } from '../utils/normalize';

export default function AbcImportPreview({
  importedTune,
  setImportedTune,
  importFields,
  customAbcOverride,
  setCustomAbcOverride,
  originalAbc,
  setOriginalAbc
}) {
  const textareaRef = useRef(null);

  // Resize textarea dynamically
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  }, [customAbcOverride]);

  // Clean and infer ABC headers on version change
  useEffect(() => {
    if (importedTune?.versions?.length) {
      const raw = importedTune.versions[importedTune.selectedIndex]?.abc || '';

      const cleaned = cleanAndFillAbc({
        rawAbc: raw,
        type: normalizeType(importedTune.type),
        key: normalizeKey(importedTune.key)
      });


      setCustomAbcOverride(cleaned);
      setOriginalAbc(cleaned);
    }
  }, [importedTune?.selectedIndex]);

  if (!importFields.abc || !importedTune?.versions?.length) return null;

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '10px',
        flexWrap: 'wrap',
        textAlign: 'center'
      }}>
       <button
        onClick={() =>
          setImportedTune(prev => ({
            ...prev,
            selectedIndex:
              (prev.selectedIndex - 1 + prev.versions.length) % prev.versions.length
          }))
        }
      >
        ◀ Prev
      </button>

     <span style={{ fontSize: '1rem', fontWeight: 500 }}>
  Version {importedTune.selectedIndex + 1} of {importedTune.versions.length}
</span>

<button
  onClick={() =>
    setImportedTune(prev => ({
      ...prev,
      selectedIndex: (prev.selectedIndex + 1) % prev.versions.length
    }))
  }
>
  Next ▶
</button>


      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
        <AbcNotation abc={customAbcOverride} />
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: '400px' }}>
          <label className="text-scaled" style={{ fontWeight: 'bold' }}>
            Edit ABC Before Saving:
          </label>
          <textarea
            ref={textareaRef}
            value={customAbcOverride}
            onChange={(e) => setCustomAbcOverride(e.target.value)}
            style={{
              fontFamily: 'monospace',
              background: '#222',
              color: '#eee',
              padding: '8px',
              borderRadius: '6px',
              marginTop: '8px',
              marginBottom: '6px',
              border: '1px solid #444',
              lineHeight: '1.4',
              overflow: 'hidden',
              resize: 'none',
              width: '100%'
            }}
          />
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
            <button
              className="big-button"
              style={{ backgroundColor: '#333', color: '#ccc', fontSize: '0.85rem', padding: '4px 8px' }}
              onClick={() => setCustomAbcOverride(originalAbc)}
            >
              Revert to Original
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
